export default function env(state = {}) {
  return state
}
